import { Component, Input, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {
  @Input() data: any;
  @Input() type: any = '';
  
  constructor(
    private commonService: CommonService,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() private dialogRef: MatDialogRef<ConfirmationComponent>
  ) { }

  ngOnInit(): void {
    // If opened directly with MatDialog.open(), use injected data
    if (this.dialogData && !this.data) {
      this.data = this.dialogData;
    }
  }

  close(closeType: string) {
    // If opened directly with MatDialog, close the dialog
    if (this.dialogRef) {
      this.dialogRef.close(closeType);
    } else {
      // Otherwise use the common service method
      this.commonService.closingPopupWithSendData(closeType);
    }
  }
}
